<template>
  <div class="">
    <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="start_date"
                persistent
                lazy
                full-width
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="start_date"
                    label="Fecha de inicio"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    class="time"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="start_date" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="modal = false">{{ $t('general.cancel') }}</v-btn>
                  <v-btn flat color="primary" @click="dateSelect(start_date, 'start_date')">{{ $t('general.accept') }}</v-btn>
                </v-date-picker>
              </v-dialog>
              
              <v-dialog
                ref="dialog2"
                v-model="modal2"
                :return-value.sync="end_date"
                persistent
                lazy
                full-width
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="end_date"
                    label="Fecha de finalización"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    id="end_date"
                    class="time"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="end_date" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="modal2 = false">{{ $t('general.cancel') }}</v-btn>
                  <v-btn flat color="primary" @click="dateSelect(end_date, 'end_date')">{{ $t('general.accept') }}</v-btn>
                </v-date-picker>
              </v-dialog>
          </v-form>
    <div class="content">
        <div>
          <div class="meta">
            <!-- <div class="filter">
                <v-text-field v-model="search" append-icon="search" label="Filtrar portadas" single-line hide-details></v-text-field>
            </div> -->
            <!-- <div class="buttons">
                <v-btn v-if="!slider" outline  @click="add" color="success">Nueva portada</v-btn>
            </div> -->
          </div>
          
        </div>
        <!-- :custom-filter="filter" -->
          <v-data-table :custom-sor="sort" :headers="headers" :items="inform" class="elevation-1" :no-results-text="message_not_found" :rows-per-page-items="pagination" :search="search"
          :rows-per-page-text="message_rows_per_page">
              <template v-slot:items="props">
                  <td>{{props.item.position}}</td>
                  <td><img class="image" :src="props.item.thumb"/></td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.section }}</td>
                  <td>{{ props.item.downloads }}</td>
              </template>
          </v-data-table>
        </div>
    </div>

  </div>
</template>

<script>
import i18n from "@/i18n";

export default {
  name: 'Inform',
  props: { page: String },
  data () {
    return {
      headers: [
          { text: i18n.t('general.headers.position'), width: "100px", align: "center", value: 'position' },
          { text: i18n.t('general.headers.preview'), width: "50px", value: 'thumb' },
          { text: i18n.t('general.name'), value: 'name', align: "left"},
          { text: i18n.t('general.headers.section'), value: 'section', align: "left"},
          { text: i18n.t('general.headers.downloads'), value: 'downloads', width: "100px", align: "center" }
      ],
      search: "",
      start_date: "",
      end_date: "",
      modal: "",
      modal2: "",
      id: -1,
      message_not_found: i18n.t('admin.views.files.message_not_found'),
      message_rows_per_page: i18n.t('admin.views.files.message_rows_per_page'),
      pagination: [
                        10,
                        20,
                        30,
                        {"text":"Todos", "value": -1}
                    ],
      add_slider: { id: -1, file: '', url: '', status: "1" },
    }
  },
  computed: {
    inform(){
       return this.$store.getters['files/getInform'];
    }
  },
  methods: {
    sort( items, search, filter ){

      items.sort( function( a, b ){
        if( a.priority < b.priority ) return -1;
        return 1;
      });

      return items;
    },

    dateSelect( date, mode) {
      switch (mode) {
        case 'start_date':
          this.$refs.dialog.save(date);
          let clickEvent = new Event('click');
          document.getElementById('end_date').dispatchEvent(clickEvent)
          break;
        case 'end_date':
          this.$refs.dialog2.save(date)
          break;
      }
    },

    informLoadData(){
      this.$store.dispatch( 'files/loadInform', {start_date: this.start_date, end_date: this.end_date} );
    }
  },
  watch: {
    end_date(){
      this.informLoadData();
    },

    start_date(){
      this.informLoadData();
    },
  },
  created() {
    this.$store.commit('setTitle', 'Informe de descargas');
    this.$store.commit('setMenuVisible', false);

    this.informLoadData();

  },
  beforeRouteLeave (to, from, next) {
      next();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>


  .sidebar-cnt {
    width: 300px;
    display: inline-block;
    float: left;
  }

  .time{
    float: left;
    width: 40%;
    margin: 40px 5% 0px;
  }

  .content {
    width: 100%;
    display: inline-block;
    float: left;
    padding: 0px 40px 50px;
    position: relative;

    .meta {
      margin-bottom: 25px;
      overflow: hidden;

      .filter {
        float: left;
        width: 400px;
      }
      .buttons {
        float: right;
      }
    }

    .image {
      width: 50%;
      padding-top: 5px;
    }
    .image2 {
      width: 50%;
    }

    .header {
      width: 100%;
      text-align: left;
      margin-bottom: 15px;
      overflow: hidden;

      .meta {
        float: left;
        width: 70%;

        .breadcrumbs {
          color: #aaa;
          display: block;
          width: 100%;

          .cat1 {
            display: inline-block;
            font-weight: bold;
            font-family: Speedee-Bold;
          }
          .cat2 {
            display: inline-block;
            
            &:before {
              content: "|";
              margin: 0 5px;

            }
          }
        }
        .title {
          background: var(--main_color);
          color: var(--dark_color);
          width: auto;
          display: inline-block;
          text-align: left;
          float: left;
          font-size: 25pt;
          font-family: Speedee-Bold;
          padding: 0 5px;
          margin: 0;
          margin-top: 5px;
          line-height: 25pt;
          padding-bottom: 5px;
        }
      }

      .filter {
        float: left;
        width: 30%;
        text-align: right;
        padding: 0 10px;

        .search {
          display: block;
          overflow: hidden;
          margin-top: 5px;
          -webkit-transition: all 1s;
          transition: all 1s;


          .input {
            border: none;
            border-bottom: 2px solid #ccc;
            padding: 5px;
            outline: none;
            background: url('/img/magnify.svg') no-repeat right 5px center;
            background-size: 20px;
            width: 100%;
            float: left;
          }
          .icon {
            display: none;
            cursor: pointer;
            width: 30px;
            height: 30px;
            background: url('/img/go.svg') no-repeat center var(--main_color);
            background-size: 20px;
            border-radius: 3px;
          }
          &.active {
            

            .input {
              width: calc( 100% - 40px );
              background: transparent;
            }
            .icon {
              display: inline-block;
            }
          }

        }
        
      }

    }

  }

</style>
